import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtCOP, whatsappHref } from "@/lib/format";
import { ArrowRight } from "lucide-react";

const FALLBACK = [
  { id: "r1", origin: "Bogotá", destination: "Aeropuerto El Dorado", price_from: 90000, duration_hours: 1, description: "Traslado dentro de la ciudad al aeropuerto para grupos de hasta 5 personas.", passengers_base: 5 },
  { id: "r2", origin: "Bogotá", destination: "Chía · Cajicá · Cota", price_from: 190000, duration_hours: 1.5, description: "Recorrido por los municipios cercanos al norte de Bogotá para hasta 5 personas.", passengers_base: 5 },
  { id: "r3", origin: "Bogotá", destination: "Melgar", price_from: 550000, duration_hours: 3, description: "Escapada a tierra caliente. Precio base para grupo de 5 personas.", passengers_base: 5 },
  { id: "r4", origin: "Bogotá", destination: "Tour Bogotá · 8 horas", price_from: 280000, duration_hours: 8, description: "Disponibilidad por 8 horas dentro de la ciudad para grupos hasta 5 personas.", passengers_base: 5 },
];

export default function PopularRoutes() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/routes").then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch(() => setItems([])); }, []);
  const list = Array.isArray(items) && items.length ? items : FALLBACK;

  return (
    <section id="rutas" data-testid="routes-section" className="py-24 md:py-32 relative">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="mb-12 max-w-2xl">
          <div className="text-[#E8C87A] text-xs uppercase tracking-[0.35em] mb-4">Rutas populares</div>
          <h2 className="font-display text-4xl md:text-5xl leading-tight text-[#F5EFE0]">
            Los destinos <span className="italic text-gold-grad">más solicitados</span> del año
          </h2>
          <p className="text-[#F5EFE0]/65 mt-4">Precios "desde" para grupos base. Cotización personalizada según pasajeros, vehículo y agenda.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {list.map((r, i) => (
            <div key={r.id} data-testid={`route-card-${i}`} className="card-lux p-6 relative group">
              <div className="flex items-center gap-2 text-[#F5EFE0]/50 text-xs uppercase tracking-wider mb-4">
                {r.origin} <ArrowRight size={12} className="text-[#E8C87A]" /> <span className="text-[#E8C87A]">{r.destination}</span>
              </div>
              <div className="font-display text-3xl text-[#F5EFE0] mb-2">
                {r.destination}
              </div>
              {r.description && <p className="text-sm text-[#F5EFE0]/55 mb-5 leading-relaxed line-clamp-2">{r.description}</p>}
              <div className="flex items-end justify-between pt-5 border-t border-[#3A3229]">
                <div>
                  <div className="text-[10px] uppercase tracking-widest text-[#F5EFE0]/50">
                    Desde {r.passengers_base ? ` · ${r.passengers_base} personas` : ""}
                  </div>
                  <div className="font-display text-2xl text-[#E8C87A]">{fmtCOP(r.price_from)}</div>
                </div>
                <a
                  href={whatsappHref("573123616674", `Hola, me interesa la ruta Bogotá → ${r.destination}`)}
                  target="_blank" rel="noreferrer"
                  className="btn-ghost-gold px-4 py-2 rounded-full text-xs"
                >
                  Cotizar
                </a>
              </div>
              {r.duration_hours && (
                <div className="absolute top-4 right-4 text-[10px] text-[#F5EFE0]/50 uppercase tracking-widest">
                  {r.duration_hours} h
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
